const appUrls = {
    LOGIN: '/login',
    LOGOUT: '/logout',
    CHANGE_PASSWORD: '/change-password',

    DASHBOARD: '/',
    CONTACT: '/contact',
    QUESTIONS: '/user-question',
    POLL_QUESTIONS: '/poll-question',
    TESTIMONIAL: '/testimonial',
    REQUEST_TESTIMONIAL: '/request-testimonial',

    GALLERY: '/gallery',
    COLLAGE: '/collage',
    STUDENT: '/student',
    PROFILE: '/profile/view',
    PROFILE_EDIT: '/profile/edit',
    COMMON_PAGE_DATA: '/common-page-data',
    COMMON_PAGE_DATA_EDIT: '/common-page-data/:id'
};

export default appUrls;
